import { InputText as PrimeInputText } from 'primereact/inputtext';
import classes from './InputText.module.scss';
import React from 'react';
import { Input as CoreInput } from '@vox/frontend-react-ui';
import { formatVersion } from '@/shared/lib/formatVersion';

interface InputTextProps {
    label?: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
    error?: string;
    isRequired?: boolean;
    placeholder?: string;
    disabled?: boolean;
    readonly?: boolean;
    className?: string;
    numeric?: boolean;
    format?: 'version';
}

/** Отображает управляемое текстовое поле с доступной подписью и ошибкой. */
const InputTextComponent: React.FC<InputTextProps> = (
    {
        label = undefined,
        name,
        value,
        onChange,
        onBlur,
        error,
        isRequired = false,
        placeholder,
        disabled = false,
        readonly = false,
        className = '',
        numeric = false,
        format,
    }
) => {

    /** Принимает текст с выбранным форматом ввода */
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (numeric) {
            const numericValue = e.target.value.replace(/\D/g, '');
            e.target.value = numericValue;
        }

        if (format === 'version') {
            e.target.value = formatVersion(e.target.value);
        }

        onChange(e);
    };

    const labelClass = `${classes.label} ${isRequired
        ? classes.required
        : ''}`;

    const inputClass = `${classes.inputText} ${error
        ? classes.error
        : ''} ${className}`;

    return (
        <CoreInput
            id={name}
            name={name}
            type="text"
            label={label}
            value={value}
            onChange={handleChange}
            onBlur={onBlur}
            disabled={disabled}
            required={isRequired}
            readOnly={readonly}
            className={inputClass}
            placeholder={placeholder || ''}
            error={error}
            classNames={{
                root: classes.wrapper,
                label: labelClass,
                error: classes.error
            }}
            renderInput={(inputProps) => <PrimeInputText
                {...inputProps}
                value={value}
            />}
        />
    );
};

export const InputText = React.memo(InputTextComponent);

InputText.displayName = 'InputText';
